import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
// import logo from '../../../Components/home/images/logo.png';
import coupleImage from '../../../assets/images/couples/Vector.png';
import { SignupContext } from '../../../context/SignupContext';
import { LoginContext } from '../../../context/LoginContext';
import { getDobLimitsForGender, isDobValidForGender } from '../../../utils/dobLimits';
import { buildGothraOptions, gothraPayloadValue } from '../../../utils/gothra';
import DobFields from '../../common/DobFields';
import { toast } from 'react-toastify';
import { isDisposableEmail } from '../../../utils/tempMailDetector';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';

const ALLOWED_PHOTO_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
const MAX_PHOTO_MB = 5;
const MAX_PHOTOS = 5;

const CreateProfile = () => {
    // Form data state

    const navigate = useNavigate();
    const { userName, APIformData, setAPIFormData, userId: signupUserId, isLoggedIn: signupLoggedIn } = useContext(SignupContext);
    const { userId: loginUserId, isLoggedIn, userData, setUserdata, userName: loginUserName } = useContext(LoginContext);
    const userId = loginUserId || signupUserId;
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [photoUploadProgress, setPhotoUploadProgress] = useState(0);
    const [photoUploadFailures, setPhotoUploadFailures] = useState(0);
    // Each entry is { file, preview }; the first one becomes the profile picture.
    const [profilePhotos, setProfilePhotos] = useState([]);
    const profilePhotoInputRef = useRef(null);

    const normalizeHobbies = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) {
            return raw
                .map((item) => {
                    if (item && typeof item === 'object' && (item.label || item.value)) {
                        const v = item.value ?? item.label;
                        return { label: String(v), value: String(v) };
                    }
                    return { label: String(item), value: String(item) };
                })
                .filter((item) => item.value);
        }
        return String(raw)
            .split(',')
            .map((h) => h.trim())
            .filter(Boolean)
            .map((h) => ({ label: h, value: h }));
    };

    const selectMenuProps = {
        menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
        menuPosition: 'fixed',
        styles: {
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
                ...base,
                borderRadius: 8,
                minHeight: 42,
                borderColor: '#ccc',
                boxShadow: 'none',
            }),
        },
    };

    const [formData, setFormData] = useState({
        // description: `Hello, I am ${userName ? userName : "Hindu Sanjogian"}. Welcome to my profile. I am ${APIformData.age} years old. My height is ${APIformData.height} Ft. This profile is created by ${APIformData.profileFor}. My mother tongue is ${APIformData.language}. I belong to a ${APIformData.family_type}. I am a ${APIformData.highest_education} and ${APIformData.occupation} by Profession. My hobbies are ${APIformData?.hobbies?.map((val, i) => ((i == 0) ? (val) : (` ${val}`)))}. If you like my profile let's connect further on HinduSanjog. Thank you...`,
        name: "",
        language: "",
        gender: "",
        looking_for: "",
        subcaste: "",
        currentlocation: (APIformData.country && typeof APIformData.country === 'object')
            ? { label: APIformData.country.label, value: APIformData.country.value }
            : { label: "India", value: "101" },
        country: (APIformData.country && typeof APIformData.country === 'object')
            ? { label: APIformData.country.label, value: APIformData.country.value }
            : { label: "India", value: "101" },
        manglik: "",
        marital_status: "",
        height: APIformData.height ? { label: `${APIformData.height} Ft`, value: `${APIformData.height}` } : "",
        weight: "",
        bdy_type: "",
        ps: "",
        ps_details: APIformData.ps_details || "",
        eating: "",
        drinking: "",
        smoking: "",
        hobbies: normalizeHobbies(APIformData?.hobbies),
        highest_edu: APIformData.highest_education ? {
            label: APIformData.highest_education,
            value: APIformData.highest_education
        } : "",
        ug_degree: "",
        occupation: APIformData.occupation ? { label: APIformData.occupation, value: APIformData.occupation } : "",
        emp_in: "",
        annual_income: "",
        organizationName: "",
        caste: null,
        sister: "",
        brother: "",
        gothra: null,
        maternalGothra: null,
        familyStatus: "",
        familyType: APIformData.family_type ? { label: APIformData.family_type, value: APIformData.family_type } : "",
        familyBelongsTo: "",
        livingWithParents: "",
        state: (APIformData.state && typeof APIformData.state === 'object')
            ? { label: APIformData.state.label, value: APIformData.state.value }
            : "",
        city: null,
        pincode: ""
    });
    // Options data state
    const [options, setOptions] = useState({
        caste: [],
        gothra: [],
        cities: [],
        countries: [],
        income: [],
        language: [],
        states: [],
        education: [],
        occupation: []
    });

    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    // Fetch all dropdown options

    const genderValue = formData.gender?.value || formData.gender || APIformData?.gender || '';
    const { maxDOB, minDOB } = useMemo(
        () => getDobLimitsForGender(genderValue),
        [genderValue]
    );

    useEffect(() => {
        if (!isLoggedIn && !signupLoggedIn) {
            navigate("/login");
            return;
        }

        if (!userId) {
            navigate("/login");
            return;
        }

        const status = Number(userData?.status);
        // Allow status 8 to stay here when user clicks Back from Desired Partner.
        if (status === 1) {
            navigate('/recently-joined-matches/');
            return;
        }

        const fetchOptions = async () => {
            try {
                setIsLoading(true);
                setErrors({});
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`
                );

                const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}admin-mat/api/education.php`);



                /////////////user data when load start (signup autofill)
                const payload = new FormData();
                payload.append("user_id", userId);
                payload.append("id", userId);

                try {
                    const profileRes = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}Register_controller/get_onboarding_profile`,
                        payload
                    );
                    const details = profileRes.data?.details;
                    if (profileRes.data?.status && details) {
                        if (details.status !== undefined && details.status !== null && details.status !== '') {
                            setUserdata((prev) => ({
                                ...prev,
                                ...details,
                                user_id: details.user_id || prev?.user_id || userId,
                                id: details.user_id || prev?.id || userId,
                                status: Number(details.status),
                            }));
                        }
                        const hobbyOptions = normalizeHobbies(details.hobbies);
                        setAPIFormData({
                            ...details,
                            hobbies: hobbyOptions.map((h) => h.value),
                        });
                        const opt = (v) => (v !== null && v !== undefined && v !== '' ? { label: String(v), value: String(v) } : "");
                        const heightVal = details.height;
                        setFormData((prev) => ({
                            ...prev,
                            name: details.name || prev.name || "",
                            email: details.email || prev.email || "",
                            gender: details.gender ? opt(details.gender) : prev.gender,
                            looking_for: details.looking_for ? opt(details.looking_for) : prev.looking_for,
                            dob: details.dob || prev.dob || "",
                            caste: details.caste ? opt(details.caste) : prev.caste,
                            pro_for: details.pro_for ? opt(details.pro_for) : prev.pro_for,
                            language: details.language ? opt(details.language) : prev.language,
                            height: heightVal
                                ? { label: `${heightVal} Ft`, value: String(heightVal) }
                                : prev.height,
                            occupation: details.occupation ? opt(details.occupation) : prev.occupation,
                            highest_edu: details.highest_edu ? opt(details.highest_edu) : prev.highest_edu,
                            familyType: details.family_type ? opt(details.family_type) : prev.familyType,
                            smoking: details.smoking ? opt(details.smoking) : prev.smoking,
                            marital_status: details.marital_status ? opt(details.marital_status) : prev.marital_status,
                            bdy_type: details.bdy_type ? opt(details.bdy_type) : prev.bdy_type,
                            ps: details.ps ? opt(details.ps) : prev.ps,
                            ps_details: details.ps_details || prev.ps_details || "",
                            eating: details.eating ? opt(details.eating) : prev.eating,
                            manglik: details.manglik ? opt(details.manglik) : prev.manglik,
                            state: details.state ? { label: details.state, value: details.state } : prev.state,
                            city: details.city ? { label: details.city, value: details.city } : prev.city,
                            pincode: details.pin || prev.pincode || "",
                            hobbies: hobbyOptions.length ? hobbyOptions : prev.hobbies,
                        }));
                    }
                } catch (err) {
                    console.log("Error While Fetching profile data", err);
                }
                /////////////user data when load end

                if (resp.data.data.education) {
                    setOptions({ education: resp.data.data.education });
                } else {
                    setOptions({ education: [] });
                }

                if (!response.data.success) {
                    throw new Error(response.data.error || "Failed to fetch options");
                }


                // Transform all options to ensure they're arrays
                const transformedOptions = {
                    caste: Array.isArray(response.data.data.caste) ? response.data.data.caste : [],
                    gothra: Array.isArray(response.data.data.gothra) ? response.data.data.gothra : [],
                    cities: Array.isArray(response.data.data.cities) ? response.data.data.cities : [],
                    countries: Array.isArray(response.data.data.countries) ? response.data.data.countries : [],
                    income: Array.isArray(response.data.data.income) ? response.data.data.income : [],
                    language: Array.isArray(response.data.data.language) ? response.data.data.language : [],
                    states: Array.isArray(response.data.data.states) ? response.data.data.states : [],
                    subCaste: Array.isArray(response.data.data.subcaste) ? response.data.data.subcaste : [],
                    education: Array.isArray(resp.data.data.education) ? resp.data.data.education : [],
                    occupation: Array.isArray(resp.data.data.occupation) ? resp.data.data.occupation : []
                };

                setOptions(transformedOptions);
            } catch (err) {
                console.error("Error fetching options:", err);
                setErrors(err.message);
                // Initialize with empty arrays if request fails
                setOptions({
                    caste: [],
                    gothra: [],
                    cities: [],
                    countries: [],
                    income: [],
                    language: [],
                    states: [],
                    subCaste: [],
                    education: [],
                    occupation: []
                });
            } finally {
                setIsLoading(false);
            }
        };



        fetchOptions();
    }, []);

    const handleAutoSave = async (table, key, value) => {
        if (!userId) return;
        let payload = new FormData();
        payload.append("id", userId);
        payload.append("table", table);
        payload.append("key", key);
        payload.append("value", value);
        axios.post(`${process.env.REACT_APP_API_BASE_URL}Register_controller/autosave`, payload)
            .then((res) => { console.log("autosaved ", res.data) })
            .catch(err => console.log("Error While Auto Save ", err));
    }

    // Handle country changes
    const handlecountryChange = async (name, selectedOption) => {
        setIsLoading(true);
        const resp = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/state.php?country=${selectedOption.value}`
        );
        setOptions(prev => ({
            ...prev,
            states: Array.isArray(resp.data.data.states) ? resp.data.data.states : [],
        }));
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption,
            state: ""
        }));
        setIsLoading(false);
    };

    // Handle country changes
    const handleStateChange = async (name, selectedOption) => {
        setIsLoading(true);
        const resp = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/city.php?state=${selectedOption.value}`
        );
        setOptions(prev => ({
            ...prev,
            cities: Array.isArray(resp.data) ? resp.data : [],
        }));
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption,
            city: ""
        }));
        setIsLoading(false);
    };

    const ChangeDesc = () => {
        // setFormData(prev => ({
        //     ...prev,
        //     description: `Hello, I am ${userName ? userName : "Hindu Sanjogian"}. Welcome to my profile. I am ${APIformData.age} years old. My height is ${(formData.height.value) ? formData.height.value : APIformData.height} Ft. This profile is created by ${APIformData.profileFor}. My mother tongue is ${APIformData.language}. I belong to a ${(formData.familyType.value) ? formData.familyType.value : APIformData.family_type}. I am a ${(formData.highest_edu.value) ? formData.highest_edu.value : APIformData.highest_education} and ${(formData.occupation.value) ? formData.occupation.value : APIformData.occupation} by Profession. My hobbies are ${((Array.isArray(formData.hobbies))) ? formData.hobbies.map((val, i) => ((i == 0) ? (val.value) : (` ${val.value}`))) : APIformData?.hobbies?.map((val, i) => ((i == 0) ? (val) : (` ${val}`)))}. If you like my profile let's connect further on HinduSanjog. Thank you...`,

        // }));
    };

    function toTitleCase(str) {
        if (!str) return '';
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    // Handle form input changes
    const handleInputChange = (e) => {
        let { name, value, dataset } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user changes value
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }

        if (name === 'dob') {
            const gVal = formData.gender?.value || formData.gender || APIformData.gender;
            if (gVal && value) {
                if (!isDobValidForGender(value, gVal)) {
                    const msg = gVal === 'Male'
                        ? 'Male must be at least 21 years old'
                        : 'Female must be at least 18 years old';
                    setErrors(prev => ({ ...prev, dob: msg }));
                } else {
                    setErrors(prev => {
                        const next = { ...prev };
                        delete next.dob;
                        return next;
                    });
                }
            }
        }

        if (name == "name")
            value = toTitleCase(value);

        // ChangeDesc();
        if (value && dataset?.table)
            handleAutoSave(dataset.table, name, value);

    };

    // Handle select changes (supports both 2-arg and 3-arg calls used in this form)
    const handleSelectChange = (tableOrName, nameOrOption, maybeOption) => {
        let table = null;
        let name;
        let selectedOption;

        if (maybeOption !== undefined) {
            table = tableOrName;
            name = nameOrOption;
            selectedOption = maybeOption;
        } else {
            name = tableOrName;
            selectedOption = nameOrOption;
        }

        if (name === 'hobbies') {
            const list = selectedOption || [];
            if (list.length > 10) {
                toast.warning('You can select a maximum of 10 hobbies');
                return;
            }
            setFormData(prev => ({
                ...prev,
                hobbies: list
            }));
            if (list.length >= 3 && list.length <= 10) {
                setErrors(prev => {
                    const next = { ...prev };
                    delete next.hobbies;
                    return next;
                });
            } else if (list.length > 0 && list.length < 3) {
                setErrors(prev => ({
                    ...prev,
                    hobbies: `Please select at least 3 hobbies (${list.length} selected)`
                }));
            } else if (list.length === 0) {
                setErrors(prev => ({
                    ...prev,
                    hobbies: 'Hobbies are required (minimum 3)'
                }));
            }
            const hobbiesStr = list.map(v => v.value).join(',');
            handleAutoSave('users', 'hobbies', hobbiesStr);
            return;
        }

        setFormData(prev => {
            const next = {
                ...prev,
                [name]: selectedOption
            };
            if (name === 'gender' && selectedOption?.value) {
                const dobVal = prev.dob || '';
                if (dobVal && !isDobValidForGender(dobVal, selectedOption.value)) {
                    next.dob = '';
                }
                const msVal = prev.marital_status?.value || prev.marital_status;
                if (selectedOption.value === 'Male' && msVal === 'Widowed') {
                    next.marital_status = { label: 'Widower', value: 'Widower' };
                } else if (selectedOption.value === 'Female' && msVal === 'Widower') {
                    next.marital_status = { label: 'Widowed', value: 'Widowed' };
                }
            }
            return next;
        });

        if (errors[name]) {
            setErrors(prev => {
                const next = { ...prev };
                delete next[name];
                return next;
            });
        }

        if (table && selectedOption && !Array.isArray(selectedOption) && selectedOption.value !== undefined) {
            handleAutoSave(table, name, selectedOption.value);
        }
    };

    const setPhotoError = (message) => {
        setErrors((prev) => {
            const next = { ...prev };
            if (message) {
                next.profilePhoto = message;
            } else {
                delete next.profilePhoto;
            }
            return next;
        });
    };

    const removeProfilePhoto = (index) => {
        setProfilePhotos((prev) => {
            const target = prev[index];
            if (target) {
                URL.revokeObjectURL(target.preview);
            }
            return prev.filter((_, i) => i !== index);
        });
        if (profilePhotoInputRef.current) {
            profilePhotoInputRef.current.value = '';
        }
        setPhotoError('');
    };

    const handleProfilePhotoChange = (e) => {
        const picked = Array.from(e.target.files || []);
        e.target.value = '';
        if (!picked.length) return;

        const accepted = [];
        let message = '';

        picked.forEach((file) => {
            if (!ALLOWED_PHOTO_TYPES.includes(file.type)) {
                message = 'Only JPG, PNG and GIF images are allowed.';
                return;
            }
            if (file.size > MAX_PHOTO_MB * 1024 * 1024) {
                message = `Each image must be under ${MAX_PHOTO_MB}MB.`;
                return;
            }
            accepted.push(file);
        });

        setProfilePhotos((prev) => {
            const room = MAX_PHOTOS - prev.length;
            if (accepted.length > room) {
                message = `You can upload up to ${MAX_PHOTOS} photos.`;
            }
            const added = accepted.slice(0, Math.max(room, 0)).map((file) => ({
                file,
                preview: URL.createObjectURL(file),
            }));
            return [...prev, ...added];
        });

        setPhotoError(message);
    };

    useEffect(() => {
        return () => {
            profilePhotos.forEach((photo) => URL.revokeObjectURL(photo.preview));
        };
        // Runs on unmount only; individual previews are revoked when removed.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const validateForm = () => {
        /////after Fill Validate form
        const newErrors = {};

        if (!formData.name) newErrors.name = "Name is Required";
        if (formData.email && isDisposableEmail(formData.email)) newErrors.email = "Temporary or disposable email addresses are not allowed.";
        if (!formData.gender) newErrors.gender = "Gender is Required";
        if (!formData.looking_for) newErrors.looking_for = "Looking For is Required";
        if (!formData.dob) newErrors.dob = "DOB is Required";
        else if (genderValue && !isDobValidForGender(formData.dob, genderValue)) {
            newErrors.dob = genderValue === 'Male'
                ? 'Male must be at least 21 years old'
                : 'Female must be at least 18 years old';
        }
        if (!formData.caste) newErrors.caste = "Caste is Required";
        if (!formData.pro_for) newErrors.pro_for = "Profile For is Required";
        if (!formData.language) newErrors.language = "Language is Required";
        // if (!formData.description.trim()) newErrors.description = "Description is Required";
        // Sub caste optional — many users skip
        // if (!formData.subcaste) newErrors.subcaste = "Sub Caste Is Required";
        if (!formData.country && !formData.currentlocation) newErrors.country = "Please Select Country";
        // if (!formData.manglik) newErrors.manglik = "Manglik is Required";
        if (!formData.marital_status) newErrors.marital_status = "Martial Status is Required";
        if (!formData.height) newErrors.height = "Height is Required";
        // if (!formData.weight) newErrors.weight = "Weight is Required";
        // if (!formData.bdy_type) newErrors.bdy_type = "Body Type is Required";
        if (!formData.ps) newErrors.ps = "Physical Status is Required";
        const currentPs = formData.ps?.value || formData.ps || APIformData.ps;
        if (currentPs === "Physically Challenged" && (!formData.ps_details || !formData.ps_details.trim())) {
            newErrors.ps_details = "Please describe the physical challenge";
        }
        // if (!formData.eating) newErrors.eating = "Eating Habits is Required";
        // if (!formData.drinking) newErrors.drinking = "Drinking Habits is Required";
        // if (!formData.smoking) newErrors.smoking = "Somking is Required";
        const hobbiesCount = Array.isArray(formData.hobbies) ? formData.hobbies.length : 0;
        if (hobbiesCount === 0) newErrors.hobbies = "Please select at least 3 hobbies";
        else if (hobbiesCount < 3) newErrors.hobbies = `Please select at least 3 hobbies (${hobbiesCount} selected)`;
        else if (hobbiesCount > 10) newErrors.hobbies = "Maximum 10 hobbies allowed";
        if (!formData.highest_edu) newErrors.highest_edu = "Highest Education is Required";
        if (!formData.ug_degree) newErrors.ug_degree = "Education Qualification is Required";
        if (!formData.occupation) newErrors.occupation = "Occupation is Required";
        if (!formData.emp_in) newErrors.emp_in = "Employed In is Required";
        // if (!formData.annual_income) newErrors.annual_income = "Annual Income is Required";
        // if (!formData.sister) newErrors.sister = "Sister(s) is Required";
        // if (!formData.brother) newErrors.brother = "Brother(s) is Required";
        // if (!formData.gothra) newErrors.gothra = "Gothra is Required";
        // if (!formData.maternalGothra) newErrors.maternalGothra = "Maternal Gothra is Required";
        if (!formData.familyStatus) newErrors.familyStatus = "Family Status is Required";
        if (!formData.familyBelongsTo) newErrors.familyBelongsTo = "Family Belongs To is Required";
        // if (!formData.familyType) newErrors.familyType = "Familty Type is Required";
        // if (!formData.livingWithParents) newErrors.livingWithParents = "Living With is Required";
        if (!formData.country) newErrors.country = "Country is Required";
        if (!formData.state) newErrors.state = "State is Required";
        if (!formData.city) newErrors.city = "City is Required";
        // if (!formData.pincode) newErrors.pincode = "Pin Code is Required";

        if (Object.keys(newErrors).length > 0) {
            newErrors.api = 'Please fill all required fields marked in red, then try again.';
            setErrors(newErrors);
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (_) {
                window.scrollTo(0, 0);
            }
            return false;
        }

        setErrors({});
        return true;
    }

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        if (!userId) {
            navigate('/login');
            return;
        }

        setIsSubmitting(true);
        setErrors({});
        try {
            const hobbiesList = Array.isArray(formData.hobbies)
                ? formData.hobbies.map((val) => val.value).join(',')
                : '';

            const displayName = formData.name || APIformData?.name || loginUserName || userName || 'Member';
            const autoDesc = `Hello, I am ${displayName}. Welcome to my profile on Hindu Sanjog.`;

            const payload = new FormData();
            payload.append('user_id', userId);
            payload.append('desc', formData.description || autoDesc);
            payload.append('sub_caste', formData.subcaste?.value || formData.subcaste || '');
            payload.append('ms', formData.marital_status?.value || formData.marital_status || '');
            payload.append('height', formData.height?.value || formData.height || '');
            payload.append('weight', formData.weight?.value || formData.weight || '');
            payload.append('body', formData.bdy_type?.value || formData.bdy_type || '');
            payload.append('ps', formData.ps?.value || formData.ps || '');
            payload.append('ps_details', formData.ps_details || '');
            payload.append('eating', formData.eating?.value || formData.eating || '');
            payload.append('drinking', formData.drinking?.value || formData.drinking || '');
            payload.append('smoking', formData.smoking?.value || formData.smoking || '');
            payload.append('hobbies', hobbiesList);
            payload.append('curr_location', formData.currentlocation?.label || formData.currentlocation?.value || formData.currentlocation || formData.country?.label || 'India');
            payload.append('city', formData.city?.label || formData.city?.value || formData.city || '');
            payload.append('country', formData.country?.label || formData.country?.value || formData.country || 'India');
            payload.append('state', formData.state?.label || formData.state?.value || formData.state || '');
            payload.append('pin', formData.pincode || '');
            payload.append("highest_edu", formData.highest_edu?.value || formData.highest_edu || '');
            payload.append("ug_degree", formData.ug_degree?.value || formData.ug_degree || '');
            payload.append("emp_in", formData.emp_in?.value || formData.emp_in || '');
            payload.append("occupation", formData.occupation?.value || formData.occupation || '');
            payload.append("org_name", formData.organizationName || formData.org_name || "");
            payload.append("annual_income", formData.annual_income?.value || formData.annual_income || '');
            payload.append("sister", formData.sister?.value || formData.sister || '');
            payload.append("brother", formData.brother?.value || formData.brother || '');
            payload.append("gothra", gothraPayloadValue(formData.gothra));
            payload.append("gothra_maternal", gothraPayloadValue(formData.maternalGothra));
            payload.append("family_status", formData.familyStatus?.value || formData.familyStatus || '');
            payload.append("family_type", formData.familyType?.value || formData.familyType || '');
            payload.append("family_based", formData.familyBelongsTo?.label || formData.familyBelongsTo?.value || formData.familyBelongsTo || '');
            payload.append("living_wth_parents", formData.livingWithParents?.value || formData.livingWithParents || '');
            payload.append("manglik", formData.manglik?.value || formData.manglik || '');
            // Keep basic signup fields in sync
            payload.append('name', formData.name || '');
            payload.append('email', formData.email || APIformData?.email || '');
            payload.append('gender', formData.gender?.value || formData.gender || '');
            payload.append('looking_for', formData.looking_for?.value || formData.looking_for || '');
            payload.append('dob', formData.dob || '');
            payload.append('caste', formData.caste?.value || formData.caste || '');
            payload.append('pro_for', formData.pro_for?.value || formData.pro_for || '');
            payload.append('language', formData.language?.value || formData.language || '');

            // Photos upload after profile save — attaching them here causes Hostinger 500s
            // (large multipart + watermark helper fatals).

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}Register_controller/upload_reg`,
                payload
            );

            if (response.data.status === 'success' || response.data.status === true) {
                let photosSaved = Number(response.data.photos_saved || 0);
                let failedPhotos = Number(response.data.photos_failed || 0);

                if (profilePhotos.length > 0 && photosSaved === 0) {
                    const uploadPhoto = async (photo) => {
                        const photoPayload = new FormData();
                        photoPayload.append('id', userId);
                        photoPayload.append(
                            'img',
                            photo.file,
                            photo.file?.name || `photo-${Date.now()}.jpg`
                        );
                        photoPayload.append(
                            'looking',
                            formData.looking_for?.value || userData?.looking_for || ''
                        );
                        photoPayload.append(
                            'gender',
                            formData.gender?.value || userData?.gender || ''
                        );
                        photoPayload.append('status', 8);
                        photoPayload.append(
                            'email',
                            formData.email || APIformData?.email || userData?.email || ''
                        );
                        const res = await axios.post(
                            `${process.env.REACT_APP_API_BASE_URL}Register_controller/uploadImage`,
                            photoPayload
                        );
                        return (
                            res.data?.status === true ||
                            res.data?.status === 'true' ||
                            res.data?.response === 'success'
                        );
                    };

                    failedPhotos = 0;
                    for (let index = 0; index < profilePhotos.length; index += 1) {
                        const photo = profilePhotos[index];
                        setPhotoUploadProgress(index + 1);
                        let saved = false;
                        for (let attempt = 0; attempt < 3 && !saved; attempt += 1) {
                            try {
                                saved = await uploadPhoto(photo);
                            } catch (photoErr) {
                                console.error('Profile photo upload error:', photoErr);
                            }
                        }
                        if (saved) {
                            photosSaved += 1;
                        } else {
                            failedPhotos += 1;
                        }
                    }
                }

                setUserdata({ ...userData, status: 8, user_id: userId });

                if (profilePhotos.length > 0 && photosSaved === 0) {
                    setPhotoUploadFailures(failedPhotos || profilePhotos.length);
                    const apiPhotoErr = Array.isArray(response.data.photo_errors)
                        ? response.data.photo_errors[0]
                        : '';
                    setErrors((prev) => ({
                        ...prev,
                        submit: apiPhotoErr
                            ? `Photo error: ${apiPhotoErr}`
                            : 'Photos could not be uploaded. Please try again or add them from your profile.',
                    }));
                    return;
                }

                navigate('/desired-partner');
            } else {
                const apiMsg = response.data.message || 'Failed to save profile. Please try again.';
                const st = response.data.current_status;
                const detail = response.data.detail;
                setErrors({
                    api: detail
                        ? `${apiMsg} (${detail})`
                        : (st !== undefined && st !== null ? `${apiMsg} (account status: ${st})` : apiMsg),
                });
                try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) { window.scrollTo(0, 0); }
            }
        } catch (error) {
            console.error('Create profile error:', error);
            let serverMsg = 'Something went wrong. Please try again.';
            const data = error?.response?.data;
            if (data && typeof data === 'object' && data.message) {
                serverMsg = data.message;
            } else if (typeof data === 'string' && data.trim()) {
                serverMsg = data.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200);
            }
            setErrors({ api: serverMsg });
            try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) { window.scrollTo(0, 0); }
        } finally {
            setIsSubmitting(false);
            setPhotoUploadProgress(0);
        }
    };

    if (isLoading) {
        return <div className='custom-loader-g'>
            <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    }

    // if (error) {
    //   return <div className="error">Error: {error}</div>;
    // }

    return (

        <>
            <div className='d-none d-md-block py-md-5'></div>

            <div className='create-profile-wrapper-container'  >
                <div className='create-profile-wrapper' >
                    <div className='container'>
                        <div className="create-profile-container">
                            {/* Left Side Form */}
                            <div className="create-profile-form-side">
                                <h1 className="create-profile-heading text-center">Create Your Account</h1>
                                {/* <p className="create-profile-subheading text-center">Start your journey here</p> */}

                                <form className="create-profile-form" onSubmit={handleSubmit}>
                                    {/* Section 1: Basic Details */}
                                    <h3 className="form-section-title text-center mb-0">Basic Details</h3>
                                    {errors.api && (
                                        <div className="alert alert-danger text-center">{errors.api}</div>
                                    )}

                                    {photoUploadFailures > 0 && (
                                        <div className="alert alert-warning text-center">
                                            <p className="mb-2">
                                                Your details were saved, but {photoUploadFailures}{' '}
                                                {photoUploadFailures === 1 ? 'photo' : 'photos'} could not be uploaded.
                                                You can add them later from your profile.
                                            </p>
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => navigate('/desired-partner')}
                                            >
                                                Continue
                                            </button>
                                        </div>
                                    )}

                                    <div className="form-group profile-photo-upload">
                                        <label className="form-label">Your Photos</label>
                                        <div className="profile-photo-grid">
                                            {profilePhotos.map((photo, index) => (
                                                <div className="profile-photo-thumb" key={photo.preview}>
                                                    <img src={photo.preview} alt={`Profile preview ${index + 1}`} />
                                                    {index === 0 && (
                                                        <span className="profile-photo-primary">Profile Pic</span>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="profile-photo-remove"
                                                        onClick={() => removeProfilePhoto(index)}
                                                        aria-label={`Remove photo ${index + 1}`}
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                            {profilePhotos.length < MAX_PHOTOS && (
                                                <label htmlFor="create-profile-photo" className="profile-photo-add">
                                                    <span className="profile-photo-add-icon">+</span>
                                                    <span>Add Photo</span>
                                                </label>
                                            )}
                                        </div>
                                        <input
                                            ref={profilePhotoInputRef}
                                            type="file"
                                            multiple
                                            accept=".jpg,.jpeg,.png,.gif,image/jpeg,image/png,image/gif"
                                            onChange={handleProfilePhotoChange}
                                            className="profile-photo-input"
                                            id="create-profile-photo"
                                        />
                                        <p className="profile-photo-hint">
                                            Add up to {MAX_PHOTOS} photos · JPG, PNG or GIF · Max {MAX_PHOTO_MB}MB each.
                                            The first photo becomes your profile picture.
                                        </p>
                                        {errors.profilePhoto && (
                                            <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>
                                                {errors.profilePhoto}
                                            </span>
                                        )}
                                    </div>

                                    {/* <div className="form-group">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            rows={6}
                                            className="form-textarea"
                                            name="description"
                                            placeholder="Write something about yourself..."
                                            value={formData.description}
                                            onChange={handleInputChange}
                                        />
                                        {errors.description && <span className="field-error" style={{
                                            color: 'red',
                                            fontSize: '12px'
                                        }}>{errors.description}</span>}

                                    </div> */}


                                    <div className="form-row">
                                        <div className='form-group'>
                                            <label className='form-label'>Full Name<span class="d-inline red">*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                className='form-control p-2'
                                                value={(formData.name) ? formData.name : (APIformData.name) ? (APIformData.name) : ""}
                                                data-table="users"
                                                // onChange={handleInputChange}
                                                onBlur={handleInputChange}
                                                placeholder="Enter your name"
                                                autoComplete="off"

                                            />
                                            {errors.name && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.name}</span>}
                                        </div>

                                        <div className='form-group'>
                                            <label className='form-label'>Religion<span class="d-inline red">*</span></label>
                                            <input readOnly
                                                type="text"
                                                name="religion"
                                                value="Hindu" className='form-control p-2'
                                                placeholder="Enter your religion"
                                            />
                                        </div>

                                    </div>

                                    <div className="form-row">

                                        <div className='form-group'>
                                            <label className="form-label">Gender<span class="d-inline red">*</span></label>

                                            <Select

                                                options={Array("Male", "Female").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.gender) ? (formData.gender) : (APIformData.gender) ? { label: APIformData.gender, value: APIformData.gender } : ""}
                                                onChange={(selected) => handleSelectChange("users", "gender", selected)}
                                                placeholder="Select Gender"
                      {...selectMenuProps} />


                                            {errors.gender && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.gender}</span>}
                                        </div>

                                        <div className='form-group'>
                                            <label className="form-label">Looking For <span class="d-inline red">*</span></label>

                                            <Select
                                                options={Array("Bride", "Groom").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.looking_for) ? (formData.looking_for) : (APIformData.looking_for) ? { label: APIformData.looking_for, value: APIformData.looking_for } : ""}
                                                onChange={(selected) => handleSelectChange("users", "looking_for", selected)}
                                                placeholder="Looking For"
                      {...selectMenuProps} />

                                            {errors.looking_for && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.looking_for}</span>}
                                        </div>
                                    </div>






                                    <div className="form-row">
                                        <div className='form-group'>
                                            <label className="form-label">Date Of Birth<span class="d-inline red">*</span></label>
                                            <DobFields
                                                name="dob"
                                                value={(formData.dob) ? (formData.dob) : (APIformData.dob) ? APIformData.dob : ""}
                                                data-table="users"
                                                onChange={handleInputChange}
                                                onBlur={handleInputChange}
                                                max={maxDOB}
                                                min={minDOB}
                                                disabled={!genderValue}
                                                title={!genderValue ? 'Select gender first' : (genderValue === 'Male' ? 'Must be 21+ years' : 'Must be 18+ years')}
                                                inputClassName="form-control p-2"
                                            />
                                            {genderValue && (
                                                <span className="field-error" style={{ color: '#888', fontSize: '12px' }}>
                                                    {genderValue === 'Male' ? 'Male: minimum age 21 years' : 'Female: minimum age 18 years'}
                                                </span>
                                            )}
                                            {errors.dob && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.dob}</span>}
                                        </div>

                                        <div className='form-group'>
                                            <label className="form-label">Caste<span class="d-inline red">*</span></label>



                                            <Select
                                                options={options?.caste?.map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.caste) ? (formData.caste) : (APIformData.caste) ? { label: APIformData.caste, value: APIformData.caste } : ""}
                                                onChange={(selected) => handleSelectChange("users", "caste", selected)}
                                                placeholder="Select caste"
                      {...selectMenuProps} />

                                            {errors.caste && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.caste}</span>}
                                        </div>

                                    </div>

                                    <div className="form-row">


                                        <div className='form-group'>
                                            <div>Create Profile For &nbsp;<span class="d-inline red">*</span></div>


                                            <Select
                                                options={Array("Self", "Son", "Daughter", "Brother", "Sister", "Friend").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.pro_for) ? (formData.pro_for) : (APIformData.pro_for) ? { label: APIformData.pro_for, value: APIformData.pro_for } : ""}
                                                onChange={(selected) => handleSelectChange("users", "pro_for", selected)}
                                                placeholder="Profile For"
                      {...selectMenuProps} />

                                            {errors.pro_for && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.pro_for}</span>}

                                        </div>


                                        <div className='form-group'>
                                            <div> Mother Tounge / Language&nbsp;<span class="d-inline red">*</span></div>
                                            <Select
                                                options={options?.language?.map(lang => ({
                                                    label: lang,
                                                    value: lang
                                                }))}

                                                value={(formData.language) ? (formData.language) : (APIformData.language) ? { label: APIformData.language, value: APIformData.language } : ""}
                                                onChange={(selected) => handleSelectChange('users', "language", selected)}
                                                placeholder="Select Language"
                                                isDisabled={options?.language?.length === 0}
                      {...selectMenuProps} />
                                            {errors.language && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.language}</span>}
                                        </div>
                                    </div>












                                    <div className="form-row">


                                        <div className='form-group'>
                                            <label className="form-label">Height (in Feet)&nbsp;<span class="d-inline red">*</span></label>
                                            <Select
                                                options={Array.from({ length: 4 }, (_, f) => 4 + f) // 4 to 7
                                                    .flatMap(feet =>
                                                        Array.from({ length: 12 }, (_, inches) => {
                                                            if (feet === 7 && inches > 0) return null;
                                                            return { label: `${feet}.${inches} Ft`, value: `${feet}.${inches}` }
                                                        }).filter(Boolean)
                                                    )}
                                                value={(formData.height) ? (formData.height) : (APIformData.height) ? { label: `${APIformData.height} Ft`, value: `${APIformData.height}` } : ""}
                                                onChange={(selected) => handleSelectChange("users", "height", selected)}
                                                placeholder="Select Height"
                      {...selectMenuProps} />
                                            {errors.height && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.height}</span>}

                                        </div>

                                        <div className='form-group'>
                                            <label className="form-label">Email ID &nbsp;<span class="d-inline red">*</span></label>
                                            <input
                                                type="email"
                                                name="email"

                                                value={(formData.email) ? (formData.email) : (APIformData.email) ? (APIformData.email) : ""}
                                                onChange={handleInputChange}
                                                data-table="users"
                                                placeholder="Enter your email"
                                                className="form-control p-2 text-lowercase"
                                            />
                                            {errors.email && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.email}</span>}
                                        </div>

                                    </div>



                                    <div className='form-row'>



                                        <div className="form-group">
                                            <label className="form-label" >Smoking Habits : </label>


                                            <Select
                                                options={Array("Yes", "No", "Occasionally").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.smoking) ? (formData.smoking) : (APIformData.smoking) ? { label: APIformData.smoking, value: APIformData.smoking } : ""}
                                                onChange={(selected) => handleSelectChange("users", "smoking", selected)}
                                                placeholder="Select Smoking Habits"
                      {...selectMenuProps} />

                                            {/* {errors.smoking && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.smoking}</span>} */}

                                        </div>

                                        {/* <div className='form-group'>
                                            <label className="form-label">Occupation&nbsp;<span class="d-inline red">*</span></label>
                                            <Select
                                                options={options?.occupation?.map(res => ({ label: res, value: res }))}
                                                value={(formData.occupation) ? (formData.occupation) : (APIformData.occupation) ? { label: APIformData.occupation, value: APIformData.occupation } : ""}
                                                onChange={(selected) => handleSelectChange("user_education", "occupation", selected)}
                                                placeholder="Select Occupation"
                      {...selectMenuProps} />
                                            {errors.occupation && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.occupation}</span>}

                                        </div> */}
                                    </div>






                                    {/* 


                                    <div className="form-group">
                                        <label className="form-label" className='mb-2'><span>Password&nbsp;<span class="d-inline red">*</span></span></label>
                                        <div className='input-group mb-0'>
                                            <input
                                                style={{ flex: 1, marginTop: 0 }}
                                                type={showPassword ? 'text' : 'password'}
                                                name="password"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                                placeholder="Enter your password"
                                                aria-label="Enter your password"
                                                aria-describedby="basic-addon2"

                                            />
                                            <span class="input-group-text" id="basic-addon2 p-1"
                                                onClick={() => (setShowPassword((prev) => !prev))}
                                                style={{ cursor: 'pointer', borderRadius: "0 15px 15px 0" }}> {showPassword ? <FaEye size={22} /> : <FaEyeSlash size={22} />} </span>
                                        </div>
                                        {errors.password && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.password}</span>}
                                    </div>   */}














                                    <div className="form-row">

                                        <div className="form-group">
                                            <label className="form-label">Sub Caste</label>
                                            <Select
                                                options={options?.subCaste?.map(caste => ({
                                                    label: caste,
                                                    value: caste
                                                }))}
                                                value={formData.subcaste}
                                                onChange={(selected) => handleSelectChange("subcaste", selected)}
                                                placeholder="Select Sub Caste"
                                                isDisabled={options.caste.length === 0}
                      {...selectMenuProps} />
                                            {errors.subcaste && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.subcaste}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Current Location (by map api)*</label>
                                            <Select
                                                options={options?.countries?.map(country => ({
                                                    label: Object.values(country).toString(),
                                                    value: (Object.keys(country).toString())
                                                }))}

                                                value={formData.currentlocation}
                                                onChange={(selected) => handleSelectChange("currentlocation", selected)}
                                                placeholder="Select Country"
                                                isDisabled={options.countries.length === 0}
                      {...selectMenuProps} />
                                            {errors.currentlocation && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.currentlocation}</span>}

                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Manglik Dosha</label>

                                            <Select
                                                options={Array("Yes", "No", "Don't Know").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={(formData.manglik) ? (formData.manglik) : (APIformData.manglik ? { label: APIformData.manglik, value: APIformData.manglik } : "")}
                                                onChange={(selected) => handleSelectChange("users","manglik", selected)}
                                                placeholder="Select Maglik"
                      {...selectMenuProps} />
                                            {/* {errors.manglik && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.manglik}</span>} */}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Marital Status <span className='red'> *</span></label>

                                            <Select
                                                options={["Single", "Divorce", (String(genderValue).toLowerCase() === 'male' || formData.looking_for?.value === 'Bride' || APIformData.looking_for === 'Bride') ? "Widower" : "Widowed"].map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={(formData.marital_status)?(formData.marital_status):(APIformData.marital_status)?{label:APIformData.marital_status,value:APIformData.marital_status}:""}
                                                onChange={(selected) => handleSelectChange("users","marital_status", selected)}
                                                placeholder="Select Marital Status"
                      {...selectMenuProps} />

                                            {errors.marital_status && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.marital_status}</span>}

                                        </div>
                                    </div>

                                    <div className="form-row">
                                        {/* <div className="form-group">
                                            <label className="form-label">Height (in feet) *</label>


                                            <Select
                                                options={Array.from({ length: 4 }, (_, f) => 4 + f) // 4 to 7
                                                    .flatMap(feet =>
                                                        Array.from({ length: 12 }, (_, inches) => {
                                                            if (feet === 7 && inches > 0) return null;
                                                            return { label: `${feet}.${inches} Ft`, value: `${feet}.${inches}` }
                                                        }).filter(Boolean)
                                                    )}


                                                value={formData.height}

                                                onChange={(selected) => handleSelectChange("height", selected)}
                                                placeholder="Select Height"
                      {...selectMenuProps} />
                                            {errors.height && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.height}</span>}

                                        </div> */}
                                        <div className="form-group">
                                            <label className="form-label">Weight (in Kg)</label>




                                            <Select
                                                options={[...Array.from({ length: 111 }, (_, i) => i + 40).map(val => ({ label: `${val} Kg`, value: `${val}` })), { label: `150+ Kg`, value: `150+` }]}

                                                value={(formData.weight) ? (formData.weight) : (APIformData.weight!=0) ? ({ label: `${APIformData.weight} Kg`, value: `${APIformData.weight}` }) : ""}
                                                onChange={(selected) => handleSelectChange("users", "weight", selected)}
                                                placeholder="Select Weight"
                      {...selectMenuProps} />

                                            {/* {errors.weight && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.weight}</span>} */}
                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Body Type *</label>

                                            <Select
                                                options={Array("Slim", "Average", "Athletic", "Heavy").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={(formData.bdy_type)?(formData.bdy_type):(APIformData.bdy_type)?{label:APIformData.bdy_type,value:APIformData.bdy_type}:""}
                                                onChange={(selected) => handleSelectChange("users","bdy_type", selected)}
                                                placeholder="Select Body Type"
                      {...selectMenuProps} />
                                            {/* {errors.bdy_type && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.bdy_type}</span>} */}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Physical Status <span className='red'>*</span></label>


                                            <Select
                                                options={Array("Normal", "Physically Challenged").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={(formData.ps)?(formData.ps):(APIformData.ps)?{label:APIformData.ps,value:APIformData.ps}:""}
                                                onChange={(selected) => handleSelectChange("users","ps", selected)}
                                                placeholder="Select Physical Status"
                      {...selectMenuProps} />
                                            {errors.ps && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.ps}</span>}

                                        </div>
                                    </div>

                                    {(formData.ps?.value === "Physically Challenged" || formData.ps === "Physically Challenged" || APIformData.ps === "Physically Challenged") && (
                                        <div className="form-row">
                                            <div className="form-group" style={{ width: '100%' }}>
                                                <label className="form-label">
                                                    Describe Physical Challenge <span className="red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="ps_details"
                                                    data-table="users"
                                                    className="form-control p-2"
                                                    value={formData.ps_details || ""}
                                                    onChange={handleInputChange}
                                                    placeholder="Describe what is physically challenged (e.g. Minor handicap, Visual, Hearing, Orthopedic, etc.)"
                                                    style={{
                                                        width: '100%',
                                                        minHeight: '42px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #ccc',
                                                        padding: '8px 14px',
                                                        fontSize: '14px',
                                                    }}
                                                />
                                                {errors.ps_details && (
                                                    <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>
                                                        {errors.ps_details}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}


                                    <div className="form-row">

                                        <div className="form-group">
                                            <label className="form-label">Eating Habits : </label>


                                            <Select
                                                options={Array("Vegetarian", "Non-Vegetarian", "Jain", "Eggetarian", "Vegan").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={(formData.eating)?(formData.eating):(APIformData.eating)?{label:APIformData.eating,value:APIformData.eating}:""}
                                                onChange={(selected) => handleSelectChange("users","eating", selected)}
                                                placeholder="Select Eating Habits"
                      {...selectMenuProps} />
                                            {/* {errors.eating && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.eating}</span>} */}



                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Drinking Habits : </label>


                                            <Select
                                                options={Array("Yes", "No", "Occasionally").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={(formData.drinking)?(formData.drinking):(APIformData.drinking)?{label:APIformData.drinking,value:APIformData.drinking}:""}
                                                onChange={(selected) => handleSelectChange("users","drinking", selected)}
                                                placeholder="Select Drinking Habits"
                      {...selectMenuProps} />

                                            {/* {errors.drinking && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.drinking}</span>} */}
                                        </div>

                                    </div>





                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Hobbies <span className="d-inline red">*</span></label>
                                            <small className="text-muted d-block mb-1" style={{ fontSize: '11px' }}>
                                                Select between 3 to 10 hobbies ({(formData.hobbies || []).length}/10 selected)
                                            </small>

                                            <Select
                                                options={[
                                                    { value: 'arts-crafts', label: 'Arts & Crafts' },
                                                    { value: 'sports-fitness', label: 'Sports & Fitness' },
                                                    { value: 'music-performing-arts', label: 'Music & Performing Arts' },
                                                    { value: 'reading-writing', label: 'Reading & Writing' },
                                                    { value: 'outdoor-nature', label: 'Outdoor & Nature Activities' },
                                                    { value: 'gaming-puzzles', label: 'Gaming & Puzzles' },
                                                    { value: 'collecting', label: 'Collecting' },
                                                    { value: 'diy-home', label: 'DIY & Home Improvement' },
                                                    { value: 'food-drink', label: 'Food & Drink' },
                                                    { value: 'tech-digital', label: 'Tech & Digital Hobbies' },
                                                    { value: 'traveling', label: 'Traveling' },
                                                    { value: 'cooking', label: 'Cooking' },
                                                    { value: 'photography', label: 'Photography' },
                                                    { value: 'dancing', label: 'Dancing' },
                                                    { value: 'gardening', label: 'Gardening' },
                                                ]}

                                                isMulti={true}
                                                value={formData.hobbies}
                                                onChange={(selected) => handleSelectChange("hobbies", selected)}
                                                placeholder="Select Hobbies (Min 3, Max 10)"
                                                isOptionDisabled={() => (formData.hobbies || []).length >= 10}
                                                {...selectMenuProps} />


                                            {errors.hobbies && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.hobbies}</span>}


                                        </div>


                                    </div>


                                    {/* Section 2: Education & Career */}
                                    <h3 className="form-section-title text-center my-2">Education & Career</h3>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Highest Education *</label>

                                            <Select
                                                options={Array("Not Educated", "10th Pass", "12th Pass", "Diploma", "Graduate", "Post Graduate", "M Phil", "PHD", "Other").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.highest_edu)?(formData.highest_edu):(APIformData.highest_edu)?{label:APIformData.highest_edu,value:APIformData.highest_edu}:""}
                                                onChange={(selected) => handleSelectChange("user_education","highest_edu", selected)}
                                                placeholder="Select Highest Education"
                      {...selectMenuProps} />


                                            {errors.highest_edu && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.highest_edu}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Education Qualification</label>

                                            <Select
                                                options={options?.education?.map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.ug_degree)?(formData.ug_degree):(APIformData.ug_degree)?{label:APIformData.ug_degree,value:APIformData.ug_degree}:""}
                                                onChange={(selected) => handleSelectChange("user_education","ug_degree", selected)}
                                                placeholder="Select Qualtification"
                      {...selectMenuProps} />


                                            {errors.ug_degree && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.ug_degree}</span>}

                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Occupation <span className='red'>*</span></label>

                                            <Select
                                                options={options?.occupation?.map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.occupation)?(formData.occupation):(APIformData.occupation)?{label:APIformData.occupation,value:APIformData.occupation}:""}
                                                onChange={(selected) => handleSelectChange("user_education","occupation", selected)}
                                                placeholder="Select Occupation"
                      {...selectMenuProps} />


                                            {errors.occupation && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.occupation}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Employed In</label>

                                            <Select
                                                options={Array("Private Sector", "Government / Puboptionc Sector", "Civil Services", "Defence", "Self- Employed", "Unemployed").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.emp_in)?(formData.emp_in):(APIformData.emp_in)?{label: APIformData.emp_in, value:APIformData.emp_in}:""}
                                                onChange={(selected) => handleSelectChange("user_education","emp_in", selected)}
                                                placeholder="Select Employed In"
                      {...selectMenuProps} />

                                            {errors.emp_in && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.emp_in}</span>}

                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Annual Income *</label>

                                            <Select
                                                options={options?.income?.map((val, index) => ({
                                                    label: val,
                                                    value: (index + 1)
                                                }))}
                                                value={(formData.annual_income)?(formData.annual_income):(APIformData.annual_income)?{label:options?.income[(APIformData.annual_income-1)],value:parseInt(APIformData.annual_income)}:""}
                                                onChange={(selected) => handleSelectChange("user_education","annual_income", selected)}
                                                placeholder="Select Income"
                      {...selectMenuProps} />


                                            {/* {errors.annual_income && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.annual_income}</span>} */}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Company Name</label>

                                            <input name="org_name" value={(formData.org_name)?(formData.org_name):(APIformData.org_name)?(APIformData.org_name):""} className='form-control p-2' data-table="user_education" onChange={handleInputChange} type='Text' />

                                        </div>
                                    </div>

                                    {/* Section 3: Family Details */}
                                    <h3 className="form-section-title text-center my-2">Family Details</h3>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Sister(s)</label>

                                            <Select
                                                options={Array("0", "1", "2", "3", "3+").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.sister)?(formData.sister):(APIformData.sister)?{label:APIformData.sister,value:APIformData.sister}:""}
                                                onChange={(selected) => handleSelectChange("user_family","sister", selected)}
                                                placeholder="Select Sister"
                      {...selectMenuProps} />


                                            {/* {errors.sister && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.sister}</span>} */}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Brother(s)</label>


                                            <Select
                                                options={Array("0", "1", "2", "3", "3+").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={(formData.brother)?(formData.brother):(APIformData.brother)?{label:APIformData.brother,value:APIformData.brother}:""}
                                                onChange={(selected) => handleSelectChange("user_family","brother", selected)}
                                                placeholder="Select Brother"
                      {...selectMenuProps} />


                                            {/* {errors.brother && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.brother}</span>} */}

                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Gothra</label>
                                            <Select
                                                options={buildGothraOptions(options.gothra)}
                                                value={formData.gothra}
                                                onChange={(selected) => handleSelectChange("user_family","gothra", selected)}
                                                placeholder="Select Gothra"
                                                isDisabled={options.gothra.length === 0}
                      {...selectMenuProps} />

                                            {/* {errors.gothra && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.gothra}</span>} */}
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Gothra (Maternal)</label>
                                            <Select
                                                options={buildGothraOptions(options.gothra)}
                                                value={formData.maternalGothra}
                                                onChange={(selected) => handleSelectChange("maternalGothra", selected)}
                                                placeholder="Select Maternal Gothra"
                                                isDisabled={options.gothra.length === 0}
                      {...selectMenuProps} />


                                            {/* {errors.maternalGothra && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.maternalGothra}</span>} */}
                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Family Status</label>


                                            <Select
                                                options={Array("Rich/Affluent", "Upper Middle", "Middle Class", "Lower Middle Class").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.familyStatus}
                                                onChange={(selected) => handleSelectChange("familyStatus", selected)}
                                                placeholder="Select Family Status"
                      {...selectMenuProps} />

                                            {errors.familyStatus && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.familyStatus}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Family Type</label>

                                            <Select
                                                options={Array("Joint Family", "Nuclear Family").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.familyType}
                                                onChange={(selected) => handleSelectChange("familyType", selected)}
                                                placeholder="Select Family Type"
                      {...selectMenuProps} />

                                            {/* {errors.familyType && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.familyType}</span>} */}

                                        </div>
                                    </div>


                                    <div className="form-row">

                                        <div className="form-group">
                                            <label className="form-label">Living with parents?</label>

                                            <Select
                                                options={Array("Yes", "No", "Not Applicable").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.livingWithParents}
                                                onChange={(selected) => handleSelectChange("livingWithParents", selected)}
                                                placeholder="Select Living With Parents"
                      {...selectMenuProps} />

                                            {/* {errors.livingWithParents && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.livingWithParents}</span>} */}

                                        </div>


                                        <div className="form-group">
                                            <label className="form-label">Country</label>

                                            <Select
                                                options={options?.countries?.map(val => ({
                                                    label: Object.values(val).toString(),
                                                    value: (Object.keys(val)).toString()
                                                }))}
                                                value={formData.country}
                                                onChange={(selected) => handlecountryChange("country", selected)}
                                                placeholder="Select Country"
                                                defaultValue={{ label: "India", value: 101 }}
                      {...selectMenuProps} />


                                            {errors.country && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.country}</span>}

                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Family Belongs To (Native State) </label>
                                            <Select
                                                options={options?.states?.map(val => ({
                                                    label: Object.values(val).toString(),
                                                    value: Object.values(val).toString()
                                                }))}
                                                value={formData.familyBelongsTo}
                                                onChange={(selected) => handleSelectChange("familyBelongsTo", selected)}
                                                placeholder="Select Family Belongs To"
                      {...selectMenuProps} />

                                            {errors.familyBelongsTo && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.familyBelongsTo}</span>}

                                        </div>


                                        <div className="form-group">
                                            <label className="form-label">Current State *</label>
                                            <Select
                                                options={options.states.map(state => ({
                                                    label: Object.values(state).toString(),
                                                    value: Object.keys(state).toString()
                                                }))}
                                                value={formData.state}
                                                onChange={(selected) => handleStateChange("state", selected)}
                                                placeholder="Select State"
                                                isDisabled={options.states.length === 0}
                      {...selectMenuProps} />


                                            {errors.state && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.state}</span>}
                                        </div>

                                    </div>


                                    <div className="form-row">

                                        <div className="form-group">
                                            <label className="form-label">Current City</label>
                                            <Select
                                                options={options.cities.map(city => ({
                                                    label: city,
                                                    value: city
                                                }))}
                                                value={formData.city}
                                                onChange={(selected) => handleSelectChange("city", selected)}
                                                placeholder="Select City"
                                                isDisabled={options.cities.length === 0}
                      {...selectMenuProps} />


                                            {errors.city && <span className="field-error"
                                                style={{ color: 'red', fontSize: '12px' }}>{errors.city}</span>}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Pin Code</label>
                                            <input type='text' className='form-control p-2' name='pincode' onChange={handleInputChange}
                                                value={formData.pincode} />

                                            {/* {errors.pincode && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.pincode}</span>} */}
                                        </div>


                                    </div>

                                    {photoUploadFailures > 0 ? (
                                        <button
                                            type="button"
                                            className="create-btn mt-3"
                                            onClick={() => navigate('/desired-partner')}
                                        >
                                            Continue
                                        </button>
                                    ) : (
                                        <button type="submit" className="create-btn mt-3" disabled={isSubmitting}>
                                            {photoUploadProgress > 0
                                                ? `Uploading photo ${photoUploadProgress} of ${profilePhotos.length}...`
                                                : isSubmitting ? 'Saving...' : 'Save Details'}
                                        </button>
                                    )}
                                </form>
                            </div>

                            {/* Right Side Image */}
                            <div className="create-profile-image-side d-none d-lg-block">
                                <img src={coupleImage} alt="Couple" className="couple-image" />
                                <div className="image-overlay">
                                    <h2 className="overlay-heading">
                                        Your Journey To Love Begins <span className="highlight">Here!</span>
                                    </h2>
                                    <p className="overlay-text">
                                        Connect With Genuine Matches Who Share Your <span
                                            className="highlight">Values</span> And <span className="highlight">Dreams</span>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <style>
                        {`


.create-profile-wrapper-container{
width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 20px;
}

.create-profile-wrapper{
width: 100%;
  max-width: 1200px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}



        /* Main Layout */

           .css-b62m3t-container{
margin-top:0 !important;
           }
        .form-group select,.form-group input
        {
        background:white;
        border-radius:15px;
        }
        .create-profile-wrapper {
        //   min-height: 100vh;
          background-color: #fff;
        }

        .create-profile-logo {
          max-width: 180px;
          margin: 20px;
        }

        .create-profile-container {
          display: flex;
          height: calc(100vh - 80px);
          overflow: hidden;
          padding:20px;
        }

        /* Form Side Styles */
        .create-profile-form-side {
          width: 60%;
          padding: 40px;
          overflow-y: auto;
          background-color: #fff;
        }

        .create-profile-heading {
          font-size: 2rem;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .profile-photo-upload {
          margin-bottom: 1.25rem;
        }

        .profile-photo-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
          gap: 10px;
          margin-bottom: 8px;
        }

        .profile-photo-thumb {
          position: relative;
          aspect-ratio: 1 / 1;
          border-radius: 14px;
          overflow: hidden;
          border: 1px solid #eee;
          background: #fafafa;
        }

        .profile-photo-thumb img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .profile-photo-primary {
          position: absolute;
          left: 6px;
          bottom: 6px;
          padding: 2px 8px;
          border-radius: 999px;
          background: rgba(229, 61, 92, 0.95);
          color: #fff;
          font-size: 10px;
          font-weight: 700;
        }

        .profile-photo-remove {
          position: absolute;
          top: 5px;
          right: 5px;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: none;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.55);
          color: #fff;
          font-size: 16px;
          line-height: 1;
          cursor: pointer;
        }

        .profile-photo-add {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 4px;
          aspect-ratio: 1 / 1;
          border-radius: 14px;
          border: 1px dashed #E53D5C;
          background: #fff5f7;
          color: #E53D5C;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          margin: 0;
        }

        .profile-photo-add-icon {
          font-size: 22px;
          line-height: 1;
        }

        .profile-photo-input {
          display: none !important;
        }

        .profile-photo-hint {
          margin: 0;
          font-size: 12px;
          color: #888;
        }

        .create-profile-subheading {
          color: #666;
          margin-bottom: 0;
          font-size: 1rem;
        }

        .create-profile-form {
          display: flex;
          flex-direction: column;
          gap: 3px 1.5rem;
        }

        .form-section-title {
        
          color: #E53D5C;
          font-size: 1.3rem;
          font-weight: 600;
        }

        /* Form Elements */
        .form-group {
          display: flex;
          flex-direction: column;
          gap:3px  0.5rem;
        }

        .form-label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #333;
        }

        .form-input,
        .form-select,
        .form-textarea {
          padding: 0.8rem;
          border-radius: 6px;
          border: 1px solid #ccc;
          font-size: 1rem;
          transition: border-color 0.2s;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #E53D5C;
        }

        .form-textarea {
          min-height: 100px;
          resize: vertical;
        }

        .form-row {
          display: flex;
          gap: 3px 1.5rem;
        }

        .form-row > .form-group {
          flex: 1;
        }

        /* Image Side Styles */
        .create-profile-image-side {
          width: 40%;
          position: relative;
          background-color: #F8E1E7;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius:16px;
        }
        .create-profile-image-side img{
          border-radius:16px;
        }


        .couple-image {
          width: 100%;
          height:100%;
                        
        }

        .image-overlay {
          text-align: center;
          max-width: 100%;
          position: absolute;
          bottom: 40px;
          padding:20px;
        }
              
    
    
    
    
    

        .overlay-heading {
          font-size: 28.8px;
          color: white;
          
          line-height: 1.3;


                    
    font-weight: 700;
    line-height: 1.4;
    margin-bottom: 12px;


        }

        .overlay-text {
          font-size: 1rem;
          color: #666;
          line-height: 1.6;
    
        color: white;
        font-weight: bold;


        }

        .highlight {
          color: #ffc107;
          font-weight: 600;
        }

        .create-btn {
          padding: 12px;
          background-color: #ff4d6d;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
          margin-top: 2rem;
        }

        .loading, .error {
          padding: 2rem;
          text-align: center;
          font-size: 1.2rem;
        }

        .error {
          color: #E53D5C;
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .create-profile-wrapper-container {
            min-height: auto;
            align-items: flex-start;
            padding: 8px 12px 24px;
            padding-top: 8px;
          }

          .create-profile-container {
            flex-direction: column;
            height: auto;
            padding: 0;
          }
          
          .create-profile-form-side,
          .create-profile-image-side {
            width: 100%;
            padding: 5px;
            margin-top: 0;
          }

          .create-profile-heading {
            margin-top: 0;
            margin-bottom: 0.5rem;
          }
          
          .form-row {
            flex-direction: column;
            gap: 3px 1rem;
          }
            .css-13cymwt-control {
            border-color: #dee2e6 !important ;
            }
          .css-13cymwt-control:hover {
            border-color: #dee2e6 !important ;
            }

            .create-profile-form{
            gap:0 1.5rem
            }

            .form-group{
            gap:3px 0.5rem;
            }


        }
        `}
                    </style>
                </div>
            </div>

        </>
    );
};

export default CreateProfile;